export const ROLE_CHARGE_AIOA_IP = 'ROLE_CHARGE_AIOA_IP';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_GUEST = 'ROLE_LECTEUR';